import { FC, useMemo, useRef } from 'react'
import CountUp from 'react-countup'
import VisibilitySensor from 'react-visibility-sensor'

const Count: FC<{ end: number | string }> = ({ end }) => {
  const countUpStarted = useRef(false)

  const { endNumber, prefix, suffix } = useMemo(() => {
    let endNumber: number = 0
    let prefix = ''
    let suffix = ''

    if (typeof end === 'number') {
      endNumber = end
    } else if (typeof end === 'string') {
      // 匹配第一个数字（整数或小数）
      const match = end.match(/(\d+(\.\d+)?)/)
      if (match) {
        endNumber = Number(match[1])
        const idx = match.index ?? 0
        prefix = end.slice(0, idx)
        suffix = end.slice(idx + match[1].length)
      } else {
        // 没有数字，全部作为前缀
        prefix = end
        endNumber = 0
      }
    }

    return { endNumber, prefix, suffix }
  }, [end])

  return (
    <CountUp end={endNumber} duration={4} suffix={suffix} prefix={prefix}>
      {({ countUpRef, start }) => (
        <VisibilitySensor
          onChange={(isVisible: boolean) => {
            if (isVisible && !countUpStarted.current) {
              countUpStarted.current = true
              start()
            }
          }}
          scrollCheck
          scrollContainer="#main"
          delayedCall
        >
          <span ref={countUpRef} />
        </VisibilitySensor>
      )}
    </CountUp>
  )
}

export default Count
